import { StatsigClient } from '@statsig/js-client';
import { proxy } from 'valtio';

type Statsig = { client?: StatsigClient };

export const statsigState = proxy<Statsig>({ client: undefined });
